import Swal from "sweetalert2";

export function showSuccessNotification(message: string): void {
    const toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
    });
    toast.fire({
        icon: 'success',
        text: message,
        padding: '10px 20px',
    });
}

export function showErrorNotification(message: string): void {
    const toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
    });
    toast.fire({
        icon: 'error',
        text: message,
        padding: '10px 20px',
    });
}

export function showWarningNotification(message: string): void {
    const toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
    });
    toast.fire({
        icon: 'warning',
        text: message,
        padding: '10px 20px',
    });
}
